module.exports = __webpack_public_path__ + "img/jslc4.444bd400.png";